
export const CodigoNotaria = '5';
export const UrlApi = 'https://nota21cal.sinfony.org/api/';

// Genesys Cloud Messenger — el UUID siempre se mapea a deploymentId
export const GenesysEnvironment ='prod';
export const GenesysDeploymentId = 'eaffb087-70f6-4996-a56e-d69e57bd9769';

// Links de redes sociales
export const SocialLinks = {
  facebook: process.env.REACT_APP_SOCIAL_FACEBOOK || 'https://www.facebook.com/',
  instagram: process.env.REACT_APP_SOCIAL_INSTAGRAM || 'https://www.instagram.com/',
  x: process.env.REACT_APP_SOCIAL_X || 'https://www.x.com/',
};
